// frontend/src/component/HomeProductCard.jsx
export function ProductCard({ p, href, onAdd }) {
  const link =
    href || `https://mi64.eight-percent.com/price?product=${encodeURIComponent(p.id)}`;
  const price = Number(p.price || 0);

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition p-3 h-full flex flex-col">
      <a href={link} className="block" aria-label={p.name || "Товар"}>
        <img
          src={p.image || "/no-image.svg"}
          alt={p.name || "Товар"}
          loading="lazy"
          className="w-full h-44 object-contain"
        />
        <div className="mt-2 text-sm text-gray-700 line-clamp-2">
          {p.name || "Без названия"}
        </div>
      </a>

      <div className="mt-1 flex items-center gap-1">
        <span className="text-green-600 text-xs">
          {p.in_stock ? "В наличии" : "Нет в наличии"}
        </span>
        {p.rating ? (
          <span className="text-xs text-amber-500">
            ★ {Number(p.rating).toFixed(1)} ({p.reviews || 0})
          </span>
        ) : null}
      </div>

      <div className="mt-auto pt-2 flex items-end justify-between">
        <div>
          {p.old_price ? (
            <div className="text-xs line-through text-gray-400">
              {Number(p.old_price).toLocaleString()} ₽
            </div>
          ) : null}
          <div className="text-lg font-semibold">
            {price ? price.toLocaleString() + " ₽" : "Цена по запросу"}
          </div>
        </div>

        <button
          onClick={() => onAdd?.(p)}
          disabled={!price}
          className="px-3 py-2 rounded-lg bg-orange-500 text-white hover:bg-orange-600 disabled:opacity-50"
        >
          В корзину
        </button>
      </div>
    </div>
  );
}
